import { render } from "./Lab.vue?vue&type=template&id=111a6aa8&scoped=true"
import script from "./Lab.vue?vue&type=script&lang=js"
export * from "./Lab.vue?vue&type=script&lang=js"

import "./Lab.vue?vue&type=style&index=0&id=111a6aa8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111a6aa8"]])

export default __exports__